import React from 'react';
// STYLE
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
// CONSTANTS
import { ITEM_TABLE_HEADER, ITEM_TABLE_HEADER_IN_MOBILE } from './tableHeaders';
import { useMediaQuery, useTheme } from '@material-ui/core';

const ItemsTableHead = props => {
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.only('xs'), { noSsr: true });

  const headerConfig = matches
    ? ITEM_TABLE_HEADER_IN_MOBILE
    : ITEM_TABLE_HEADER;

  return (
    <TableHead>
      <TableRow>
        {headerConfig.map(header => {
          return <TableCell key={header.ref}>{header.displayName}</TableCell>;
        })}
      </TableRow>
    </TableHead>
  );
};

export default ItemsTableHead;
